var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkingHours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#DEF5F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 28C13 19.7155 19.7155 13 28 13C36.2845 13 43 19.7155 43 28C43 36.2845 36.2845 43 28 43C19.7155 43 13 36.2845 13 28ZM29.5 22C29.5 21.6022 29.342 21.2206 29.0607 20.9393C28.7794 20.658 28.3978 20.5 28 20.5C27.6022 20.5 27.2206 20.658 26.9393 20.9393C26.658 21.2206 26.5 21.6022 26.5 22V28C26.5001 28.3978 26.6582 28.7793 26.9395 29.0605L31.4395 33.5605C31.7224 33.8337 32.1013 33.9849 32.4946 33.9815C32.8879 33.9781 33.2641 33.8203 33.5422 33.5422C33.8203 33.2641 33.9781 32.8879 33.9815 32.4946C33.9849 32.1013 33.8337 31.7224 33.5605 31.4395L29.5 27.379V22Z",
    fill: "#011CBE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingHours);
export default __webpack_public_path__ + "static/media/working-hours.9b363533e34ab13ca991b4affa36a3bd.svg";
export { ForwardRef as ReactComponent };